import { render, staticRenderFns } from "./TipsHbrb.vue?vue&type=template&id=52f25397&scoped=true"
import script from "./TipsHbrb.vue?vue&type=script&lang=js"
export * from "./TipsHbrb.vue?vue&type=script&lang=js"
import style0 from "./TipsHbrb.vue?vue&type=style&index=0&id=52f25397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f25397",
  null
  
)

export default component.exports